// --- Dependencies -------------------------------------------------------------------------------
import { NavLink } from "react-router-dom";
// --- Our Modules --------------------------------------------------------------------------------
import useNavTabs from "@/hooks/useNavTabs";
import useTranslation from "@/hooks/useTranslation";
import "./styles.css";

// --- Types --------------------------------------------------------------------------------------

type Props = {
    isOpen: boolean;
};

// --- Logic --------------------------------------------------------------------------------------

export default function SideBar({ isOpen }: Props) {
    const t = useTranslation();
    const { mainTabs } = useNavTabs();

    return (
        <aside className="side-bar" data-open={isOpen}>
            {/* Where `clients-web` puts its store switcher. Admins are cross-tenant, so there is
                nothing to switch between — the slot carries the brand instead of going empty. */}
            <div className="side-bar-brand">
                <img className="side-bar-brand-logo" src="/logo-mini-round.svg" alt="Menuket" />
                <p className="side-bar-brand-name">{t.login.title}</p>
            </div>

            <div className="side-bar-divider" />

            <nav className="side-bar-nav">
                {mainTabs.map((tab) => (
                    <NavLink
                        key={tab.path}
                        to={tab.path}
                        end={tab.path === "/"}
                        className={({ isActive }) => `side-bar-btn${isActive ? " active" : ""}`}
                    >
                        <img className="side-bar-btn-icon side-bar-btn-icon--dark" src={`/icons/side-bar/${tab.icon}-icon-dark.svg`} alt="" />
                        <img className="side-bar-btn-icon side-bar-btn-icon--white" src={`/icons/side-bar/${tab.icon}-icon-white.svg`} alt="" />
                        <span className="side-bar-btn-label">{tab.label}</span>
                    </NavLink>
                ))}
            </nav>

            <div className="side-bar-spacer" />
        </aside>
    );
}
